import styled from 'styled-components';

export const PrizeDrawDetailContainerWrapper = styled.div`
  max-height: 100vh;
  overflow: hidden;
`;
